module.exports = __webpack_public_path__ + "img/img54.2ddb0c31.svg";